import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import PrimaryButton from "../../Components/Buttons/primary-button";
import OutlinedButton from "../../Components/Buttons/outline-button";

import { renderDeleteFidelCard } from "../../Organisms/Modals/Fidel/delete-fidel-card";

import useFidel from "../../CustomHooks/useFidel";

import { useModalContext } from "../../Contexts/ModalContext";

import { useGetFidelCards } from "../../CustomHooks/Queries";

import { AmericanExpress, Mastercard, VisaLogo, DebitCards } from "../../Assets/Images/";
import { ArrowLeftCircle, Trash } from "../../Assets/Icons";

const FidelCard = ({ card }) => {
  const modalContext = useModalContext();

  const handleDeleteFidelCard = (e, card) => {
    e.stopPropagation();
    renderDeleteFidelCard(modalContext, card);
  };

  const cardCompanyLogo = useMemo(() => {
    if (card?.card_type === "Visa") {
      return <VisaLogo />;
    } else if (card?.card_type === "Amex") {
      return <AmericanExpress />;
    } else if (card?.card_type === "Mastercard") {
      return <Mastercard />;
    } else {
      return <VisaLogo />;
    }
  }, [card?.card_type]);

  return (
    <div className="fidel-card">
      <div className="card-info">
        <div className="card-logo">{cardCompanyLogo}</div>
        <div className="card-details">
          <span className="card-type">*******{card?.card_last_4_digits}</span>
          <span className="card-expiry">
            Exp. date: {card?.exp_month}/{card?.exp_year % 100}
          </span>
        </div>
      </div>
      <div className="actions">
        <button className="delete" onClick={(e) => handleDeleteFidelCard(e, card)}>
          <Trash />
        </button>
      </div>
    </div>
  );
};

function NeighborhoodNetworkCards() {
  const navigate = useNavigate();

  const { isLoadingFidel, linkingCard, LinkCard } = useFidel();

  const { isLoading: isLoadingFidelCards, data: fidelCards } = useGetFidelCards();

  const stakeCheckingCards = useMemo(() => fidelCards?.filter((card) => card.is_stake_checking), [fidelCards]);
  const otherCards = useMemo(() => fidelCards?.filter((card) => !card.is_stake_checking), [fidelCards]);

  const isLoading = isLoadingFidelCards || isLoadingFidel;

  return (
    <div className="neighborhood-network linked-cards">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            <div className="section-header">
              <button className="go-back-button" onClick={() => navigate(-1)}>
                <ArrowLeftCircle />
              </button>
              <h3 className="section-title">My Cards</h3>
              <div className="dummy"></div>
            </div>
            {isLoading ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : fidelCards?.length > 0 ? (
              <div className="content">
                <div className="top-container">
                  {stakeCheckingCards.length > 0 && (
                    <>
                      <h4 className="text-lg-semibold color--mist mb-4">Stake Checking Card</h4>
                      {stakeCheckingCards.map((card, idx) => (
                        <FidelCard key={idx} card={card} />
                      ))}
                    </>
                  )}
                  <h4 className="text-lg-semibold color--mist mb-4">Other Cards</h4>
                  {otherCards.map((card, idx) => (
                    <FidelCard key={idx} card={card} />
                  ))}
                </div>
                <div className="bottom-container">
                  <PrimaryButton onClick={LinkCard} disabled={linkingCard}>
                    Add New Card {linkingCard && <CircularProgress />}
                  </PrimaryButton>
                </div>
              </div>
            ) : (
              <div className="no-debit-cards">
                <div className="card-icon mb-8">
                  <DebitCards />
                </div>
                <h2 className="no-cards-title mb-1">No Cards Linked</h2>
                <p className="no-cards-message mb-sm-6 mb-5">You don’t have any cards linked to Fidel.</p>
                <OutlinedButton onClick={LinkCard} disabled={linkingCard}>
                  Link Credit or Debit Card {linkingCard && <CircularProgress />}
                </OutlinedButton>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default NeighborhoodNetworkCards;
